// import React, { useState } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import '../Styles/Slidebar.css';
// import { RiDashboardFill } from "react-icons/ri";
// import { FaUserGroup } from "react-icons/fa6";
// import { MdDirectionsBus } from "react-icons/md";
// import { MdOutlineBusAlert } from "react-icons/md";
// import { BiMale } from "react-icons/bi";
// import { FaRoute } from "react-icons/fa6";
// import { TbBrandBooking } from "react-icons/tb";
// import { MdPayment } from "react-icons/md";
// import { RiCoupon4Fill } from "react-icons/ri";
// import { FaUserTie } from "react-icons/fa6";
// import { FaCommentDollar } from "react-icons/fa6";
// import { MdAirlineSeatLegroomExtra } from "react-icons/md";
// import { CgProfile } from "react-icons/cg";
// import { TfiWrite } from "react-icons/tfi";
// import { FiUsers } from "react-icons/fi";
// import { FaDownload } from "react-icons/fa";
// import { IoMdCloudDownload } from "react-icons/io";

// const allMenuItems = [
//   { id: 'dashboard', label: 'Dashboard', icon: <RiDashboardFill style={{width: "100%"}}/> },
//   { id: 'customers', label: 'Customer Report', icon: <FaUserGroup style={{width: "100%"}}/> },
//   { id: 'GSTManagement', label: 'GSTManagement', icon: <FaUserGroup style={{width: "100%"}}/> },
//   { id: 'GSTAdminPanel', label: 'GSTAdminPanel Report', icon: <FaUserGroup style={{width: "100%"}}/> },
//   { id: 'drivers', label: 'Driver Manage', icon: <MdDirectionsBus style={{width: "100%"}}/> }, 
//   { id: 'conductors', label: 'Conductor Manage', icon: <MdOutlineBusAlert style={{width: "100%"}}/> }, 
//   { id: 'bus-owners', label: 'Bus Owner Manage', icon: <BiMale style={{width: "100%"}}/> },
//   { id: 'primary-busowners', label: 'Primary Bus Owner Manage', icon: <BiMale style={{width: "100%"}}/> },
//   { id: 'BusManagement', label: 'Bus Manage', icon: <BiMale style={{width: "100%"}}/> },
//    { id: 'bus-report', label: 'Bus Report', icon: <BiMale style={{width: "100%"}}/> },
// { id: 'bus-owner-report', label: 'Bus Owner Report', icon: <FaUserTie style={{width: "100%"}}/> },
//   { id: 'employees', label: 'Employee Manage', icon: <FaUserTie style={{width: "100%"}}/> },
//   { id: 'freelancers', label: 'Freelancer Manage', icon: <FiUsers style={{width: "100%"}}/> },
//   { id: 'routes', label: 'Route Manage', icon: <FaRoute style={{width: "100%"}}/> }, 
//   { id: 'primary-routes', label: 'Primary Routes Manage', icon: <FaRoute style={{width: "100%"}}/> }, 
//   { id: 'view-routes', label: 'View Routes', icon: <FaRoute style={{width: "100%"}}/> },
//   { id: 'busroutes', label: 'Bus Route Manage', icon: <FaRoute style={{width: "100%"}}/> }, 
//   { id: 'masterroutes', label: 'Route Master', icon: <FaRoute style={{width: "100%"}}/> }, 
//   { id: 'bookings', label: 'Booking Manage', icon: <TbBrandBooking style={{width: "100%"}}/> },
//   { id: 'payments', label: 'Payment Report', icon: <MdPayment style={{width: "100%"}}/> },
//   { id: 'coupons', label: 'Coupon Manage', icon: <RiCoupon4Fill style={{width: "100%"}}/> },
//   { id: 'influencers', label: 'Influencer Manage', icon: <FaUserTie style={{width: "100%"}}/> },
//   { id: 'owner-commissions', label: 'Owner Commission', icon: <FaCommentDollar style={{width: "100%"}}/> },
//   { id: 'profit-report', label: 'Bus Wise Profit Report', icon: <FaCommentDollar style={{width: "100%"}}/> },
//   { id: 'expenses-report', label: 'Expenses Report', icon: <FaCommentDollar style={{width: "100%"}}/> },
//   { id: 'influencer-commissions', label: 'Influencer Commission', icon: <FaCommentDollar style={{width: "100%"}}/> },
//   { id: 'seat-management', label: 'Seat Management', icon: <MdAirlineSeatLegroomExtra style={{width: "100%"}}/> },
//   { id: 'customer-care', label: 'Customer Care', icon: <FaUserGroup style={{width: "100%"}}/> },
//   { id: 'platform-management', label: 'platform-management', icon: <MdAirlineSeatLegroomExtra style={{width: "100%"}}/> },
//   { id: 'BookingPolicyManagement', label: 'Booking Policy Management', icon: <MdAirlineSeatLegroomExtra style={{width: "100%"}}/> },
//    { id: 'versions', label: 'Version Management', icon: <FaUserGroup style={{width: "100%"}}/> }, 
//   { id: 'profile', label: 'Profile Manage', icon: <CgProfile style={{width: "100%"}}/> },
//   { id: 'terms', label: 'Terms & Conditions', icon: <TfiWrite style={{width: "100%"}}/> },
// ];

// const Slidebar = ({ 
//   activeMenu, 
//   setActiveMenu, 
//   onToggleCompact,
//   userRole,
//   allowedMenus,
//   isAdmin,
//   isFreelancer 
// }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [downloading, setDownloading] = useState({ user: false, partner: false });

//   const filteredMenuItems = allMenuItems.filter(item => 
//     allowedMenus.includes(item.id)
//   );

//   const handleMenuClick = (menuId) => {
//     setActiveMenu(menuId);
//     navigate(`/${menuId}`);
//   };

//   const isActive = (menuId) => {
//     const currentPath = location.pathname.substring(1);
//     return currentPath === menuId || (menuId === 'dashboard' && currentPath === '');
//   };

//  const handleDownload = (type) => {
//   setDownloading(prev => ({ ...prev, [type]: true }));

//   const apkUrl = type === 'user' 
//     ? '/apks/user-app.apk' 
//     : '/apks/partner-app.apk';
  
//   const link = document.createElement('a');
//   link.href = apkUrl;
//   link.download = `roam-${type}-app.apk`;
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
  
//   setTimeout(() => {
//     setDownloading(prev => ({ ...prev, [type]: false }));
//   }, 2000);
// };

//   return (
//     <div className="sidebar">
//       <div className="sidebar-header">
//         <h2>ROAM</h2>
//         {isFreelancer && (
//           <span style={{
//             backgroundColor: '#ffc107',
//             color: '#212529',
//             padding: '2px 8px',
//             borderRadius: '12px',
//             fontSize: '10px',
//             fontWeight: '600',
//             marginLeft: '8px'
//           }}>
//             Freelancer
//           </span>
//         )}
//         {isAdmin && (
//           <span style={{
//             backgroundColor: '#28a745',
//             color: 'white',
//             padding: '2px 8px',
//             borderRadius: '12px',
//             fontSize: '10px',
//             fontWeight: '600',
//             marginLeft: '8px'
//           }}>
//             Admin
//           </span>
//         )}
//       </div>

//       <nav className="sidebar-nav">
//         <ul>
//           {filteredMenuItems.map(item => (
//             <li key={item.id}>
//               <button
//                 className={`nav-item ${isActive(item.id) ? 'active' : ''}`}
//                 onClick={() => handleMenuClick(item.id)}
//               >
//                 <span className="nav-icon">{item.icon}</span>
//                 <span className="nav-label">{item.label}</span>
//               </button>
//             </li>
//           ))}
//         </ul>
//       </nav>


//       <div className="sidebar-footer" style={{
//         padding: '15px 20px',
//         borderTop: '1px solid #444',
//         fontSize: '12px',
//         color: '#888',
//         backgroundColor: 'rgba(0,0,0,0.2)'
//       }}>
//         <div>Logged in as:</div>
//         <div style={{ fontWeight: 'bold', color: '#fff' }}>
//           {isFreelancer ? 'Freelancer' : isAdmin ? 'Administrator' : 'User'}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Slidebar;

// import React, { useState } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import '../Styles/Slidebar.css';
// import { RiDashboardFill } from "react-icons/ri";
// import { FaUserGroup } from "react-icons/fa6";
// import { MdDirectionsBus } from "react-icons/md";
// import { MdOutlineBusAlert } from "react-icons/md";
// import { BiMale } from "react-icons/bi";
// import { FaRoute } from "react-icons/fa6";
// import { TbBrandBooking } from "react-icons/tb";
// import { MdPayment } from "react-icons/md";
// import { RiCoupon4Fill } from "react-icons/ri";
// import { FaUserTie } from "react-icons/fa6";
// import { FaCommentDollar } from "react-icons/fa6";
// import { MdAirlineSeatLegroomExtra } from "react-icons/md";
// import { CgProfile } from "react-icons/cg";
// import { TfiWrite } from "react-icons/tfi";
// import { FiUsers } from "react-icons/fi";
// import { FaDownload } from "react-icons/fa";
// import { IoMdCloudDownload } from "react-icons/io";
// import { FaChevronDown, FaChevronRight } from "react-icons/fa";
// import { MdOutlineStarPurple500 } from "react-icons/md";

// // ============================================================
// // MENU CONFIG — flat items + one grouped section ("Primary")
// // ============================================================
// const allMenuItems = [
//   { id: 'dashboard', label: 'Dashboard', icon: <RiDashboardFill style={{ width: "100%" }} /> },
//   { id: 'customers', label: 'Customer Report', icon: <FaUserGroup style={{ width: "100%" }} /> },
//   { id: 'GSTManagement', label: 'GSTManagement', icon: <FaUserGroup style={{ width: "100%" }} /> },
//   { id: 'GSTAdminPanel', label: 'GSTAdminPanel Report', icon: <FaUserGroup style={{ width: "100%" }} /> },
//   { id: 'drivers', label: 'Driver Manage', icon: <MdDirectionsBus style={{ width: "100%" }} /> },
//   { id: 'conductors', label: 'Conductor Manage', icon: <MdOutlineBusAlert style={{ width: "100%" }} /> },
//   { id: 'bus-owners', label: 'Bus Owner Manage', icon: <BiMale style={{ width: "100%" }} /> },

//   // ⭐ Grouped section
//   {
//     id: 'primary-section',
//     label: 'Primary',
//     icon: <MdOutlineStarPurple500 style={{ width: "100%" }} />,
//     isGroup: true,
//     children: [
//       { id: 'primary-routes', label: 'Primary Route Manage', icon: <FaRoute style={{ width: "100%" }} /> },
//       { id: 'primary-busowners', label: 'Primary Bus Owner Manage', icon: <BiMale style={{ width: "100%" }} /> }
//     ]
//   },

//   { id: 'BusManagement', label: 'Bus Manage', icon: <BiMale style={{ width: "100%" }} /> },
//   { id: 'bus-report', label: 'Bus Report', icon: <BiMale style={{ width: "100%" }} /> },
//   { id: 'bus-owner-report', label: 'Bus Owner Report', icon: <FaUserTie style={{ width: "100%" }} /> },
//   { id: 'employees', label: 'Employee Manage', icon: <FaUserTie style={{ width: "100%" }} /> },
//   { id: 'freelancers', label: 'Freelancer Manage', icon: <FiUsers style={{ width: "100%" }} /> },
//   { id: 'routes', label: 'Route Manage', icon: <FaRoute style={{ width: "100%" }} /> },
//   { id: 'view-routes', label: 'View Routes', icon: <FaRoute style={{ width: "100%" }} /> },
//   { id: 'busroutes', label: 'Bus Route Manage', icon: <FaRoute style={{ width: "100%" }} /> },
//   { id: 'masterroutes', label: 'Route Master', icon: <FaRoute style={{ width: "100%" }} /> },
//   { id: 'bookings', label: 'Booking Manage', icon: <TbBrandBooking style={{ width: "100%" }} /> },
//   { id: 'payments', label: 'Payment Report', icon: <MdPayment style={{ width: "100%" }} /> },
//   { id: 'coupons', label: 'Coupon Manage', icon: <RiCoupon4Fill style={{ width: "100%" }} /> },
//   { id: 'influencers', label: 'Influencer Manage', icon: <FaUserTie style={{ width: "100%" }} /> },
//   { id: 'owner-commissions', label: 'Owner Commission', icon: <FaCommentDollar style={{ width: "100%" }} /> },
//   { id: 'profit-report', label: 'Bus Wise Profit Report', icon: <FaCommentDollar style={{ width: "100%" }} /> },
//   { id: 'expenses-report', label: 'Expenses Report', icon: <FaCommentDollar style={{ width: "100%" }} /> },
//   { id: 'influencer-commissions', label: 'Influencer Commission', icon: <FaCommentDollar style={{ width: "100%" }} /> },
//   { id: 'seat-management', label: 'Seat Management', icon: <MdAirlineSeatLegroomExtra style={{ width: "100%" }} /> },
//   { id: 'customer-care', label: 'Customer Care', icon: <FaUserGroup style={{ width: "100%" }} /> },
//   { id: 'BookingPolicyManagement', label: 'Booking Policy Management', icon: <MdAirlineSeatLegroomExtra style={{ width: "100%" }} /> },
//   { id: 'versions', label: 'Version Management', icon: <FaUserGroup style={{ width: "100%" }} /> },
//   { id: 'profile', label: 'Profile Manage', icon: <CgProfile style={{ width: "100%" }} /> },
//   { id: 'terms', label: 'Terms & Conditions', icon: <TfiWrite style={{ width: "100%" }} /> },
// ];

// // ============================================================
// // HELPERS
// // ============================================================
// const isGroupAllowed = (group, allowedMenus) => {
//   if (!group.isGroup) return allowedMenus.includes(group.id);
//   return group.children.some(child => allowedMenus.includes(child.id));
// };

// const filterChildren = (group, allowedMenus) => {
//   if (!group.isGroup) return group;
//   return {
//     ...group,
//     children: group.children.filter(child => allowedMenus.includes(child.id))
//   };
// };

// // ============================================================
// // SIDEBAR
// // ============================================================
// const Slidebar = ({
//   activeMenu,
//   setActiveMenu,
//   onToggleCompact,
//   userRole,
//   allowedMenus,
//   isAdmin,
//   isFreelancer
// }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [downloading, setDownloading] = useState({ user: false, partner: false });

//   // ⭐ Control which groups are expanded. Auto-open group if a child is active.
//   const [openGroups, setOpenGroups] = useState(() => {
//     const path = location.pathname.substring(1);
//     const open = {};
//     allMenuItems.forEach(item => {
//       if (item.isGroup && item.children.some(c => c.id === path)) {
//         open[item.id] = true;
//       }
//     });
//     return open;
//   });

//   // Auto-open group when navigating to a child route
//   React.useEffect(() => {
//     const path = location.pathname.substring(1);
//     allMenuItems.forEach(item => {
//       if (item.isGroup && item.children.some(c => c.id === path)) {
//         setOpenGroups(prev => ({ ...prev, [item.id]: true }));
//       }
//     });
//   }, [location.pathname]);

//   const toggleGroup = (groupId) => {
//     setOpenGroups(prev => ({ ...prev, [groupId]: !prev[groupId] }));
//   };

//   const visibleMenu = allMenuItems
//     .filter(item => isGroupAllowed(item, allowedMenus))
//     .map(item => filterChildren(item, allowedMenus));

//   const handleMenuClick = (menuId) => {
//     setActiveMenu(menuId);
//     navigate(`/${menuId}`);
//   };

//   const isActive = (menuId) => {
//     const currentPath = location.pathname.substring(1);
//     return currentPath === menuId || (menuId === 'dashboard' && currentPath === '');
//   };

//   const handleDownload = (type) => {
//     setDownloading(prev => ({ ...prev, [type]: true }));
//     const apkUrl = type === 'user' ? '/apks/user-app.apk' : '/apks/partner-app.apk';
//     const link = document.createElement('a');
//     link.href = apkUrl;
//     link.download = `roam-${type}-app.apk`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     setTimeout(() => {
//       setDownloading(prev => ({ ...prev, [type]: false }));
//     }, 2000);
//   };

//   return (
//     <div className="sidebar">
//       <div className="sidebar-header">
//         <h2>ROAM</h2>
//         {isFreelancer && (
//           <span style={{
//             backgroundColor: '#ffc107', color: '#212529',
//             padding: '2px 8px', borderRadius: '12px',
//             fontSize: '10px', fontWeight: '600', marginLeft: '8px'
//           }}>Freelancer</span>
//         )}
//         {isAdmin && (
//           <span style={{
//             backgroundColor: '#28a745', color: 'white',
//             padding: '2px 8px', borderRadius: '12px',
//             fontSize: '10px', fontWeight: '600', marginLeft: '8px'
//           }}>Admin</span>
//         )}
//       </div>

//       <nav className="sidebar-nav">
//         <ul>
//           {visibleMenu.map(item => {
//             // ---------- GROUP ITEM ----------
//             if (item.isGroup) {
//               const isOpen = !!openGroups[item.id];
//               const hasActiveChild = item.children.some(c => isActive(c.id));

//               return (
//                 <li key={item.id}>
//                   <button
//                     className={`nav-item nav-group-item ${hasActiveChild ? 'has-active-child' : ''}`}
//                     onClick={() => toggleGroup(item.id)}
//                     aria-expanded={isOpen}
//                   >
//                     <span className="nav-icon">{item.icon}</span>
//                     <span className="nav-label">{item.label}</span>
//                     <span className="nav-group-chevron" style={{
//                       marginLeft: 'auto',
//                       display: 'flex',
//                       alignItems: 'center',
//                       fontSize: '11px',
//                       transition: 'transform 0.2s ease',
//                       transform: isOpen ? 'rotate(0deg)' : 'rotate(0deg)'
//                     }}>
//                       {isOpen ? <FaChevronDown /> : <FaChevronRight />}
//                     </span>
//                   </button>

//                   {/* Sub-menu */}
//                   <div
//                     className={`nav-group-children ${isOpen ? 'open' : ''}`}
//                     style={{
//                       maxHeight: isOpen ? `${item.children.length * 52}px` : '0px',
//                       overflow: 'hidden',
//                       transition: 'max-height 0.28s ease',
//                       backgroundColor: 'rgba(0,0,0,0.15)'
//                     }}
//                   >
//                     <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
//                       {item.children.map(child => (
//                         <li key={child.id}>
//                           <button
//                             className={`nav-item nav-child-item ${isActive(child.id) ? 'active' : ''}`}
//                             onClick={() => handleMenuClick(child.id)}
//                             style={{ paddingLeft: '48px' }}
//                           >
//                             <span className="nav-icon" style={{ opacity: 0.85 }}>
//                               {child.icon}
//                             </span>
//                             <span className="nav-label" style={{ fontSize: '13px' }}>
//                               {child.label}
//                             </span>
//                           </button>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 </li>
//               );
//             }

//             // ---------- NORMAL ITEM ----------
//             return (
//               <li key={item.id}>
//                 <button
//                   className={`nav-item ${isActive(item.id) ? 'active' : ''}`}
//                   onClick={() => handleMenuClick(item.id)}
//                 >
//                   <span className="nav-icon">{item.icon}</span>
//                   <span className="nav-label">{item.label}</span>
//                 </button>
//               </li>
//             );
//           })}
//         </ul>
//       </nav>

//       <div className="sidebar-footer" style={{
//         padding: '15px 20px',
//         borderTop: '1px solid #444',
//         fontSize: '12px',
//         color: '#888',
//         backgroundColor: 'rgba(0,0,0,0.2)'
//       }}>
//         <div>Logged in as:</div>
//         <div style={{ fontWeight: 'bold', color: '#fff' }}>
//           {isFreelancer ? 'Freelancer' : isAdmin ? 'Administrator' : 'User'}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Slidebar;


import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../Styles/Slidebar.css';
import { RiDashboardFill } from "react-icons/ri";
import { FaUserGroup } from "react-icons/fa6";
import { MdDirectionsBus } from "react-icons/md";
import { MdOutlineBusAlert } from "react-icons/md";
import { BiMale } from "react-icons/bi";
import { FaRoute } from "react-icons/fa6";
import { TbBrandBooking } from "react-icons/tb";
import { MdPayment } from "react-icons/md";
import { RiCoupon4Fill } from "react-icons/ri";
import { FaUserTie } from "react-icons/fa6";
import { FaCommentDollar } from "react-icons/fa6";
import { MdAirlineSeatLegroomExtra } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { TfiWrite } from "react-icons/tfi";
import { FiUsers } from "react-icons/fi";
import { IoMdCloudDownload } from "react-icons/io";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { MdOutlineStarPurple500 } from "react-icons/md";

// ============================================================
// MENU CONFIG — flat items + one grouped section ("Primary")
// ============================================================
const allMenuItems = [
  { id: 'dashboard',      label: 'Dashboard',              icon: <RiDashboardFill />,              tone: 'cyan' },
  { id: 'customers',      label: 'Customer Report',        icon: <FaUserGroup />,                  tone: 'indigo' },
  { id: 'GSTManagement',  label: 'GST Management',         icon: <FaUserGroup />,                  tone: 'green' },
  { id: 'GSTAdminPanel',  label: 'GST Admin Report',       icon: <FaUserGroup />,                  tone: 'green' },
  { id: 'drivers',        label: 'Driver Manage',          icon: <MdDirectionsBus />,              tone: 'amber' },
  { id: 'conductors',     label: 'Conductor Manage',       icon: <MdOutlineBusAlert />,            tone: 'amber' },
  { id: 'bus-owners',     label: 'Bus Owner Manage',       icon: <BiMale />,                       tone: 'amber' },

 
  // {
  //   id: 'primary-section',
  //   label: 'Primary',
  //   icon: <MdOutlineStarPurple500 />,
  //   tone: 'amber',
  //   isGroup: true,
  //   children: [
  //     { id: 'primary-routes',    label: 'Primary Route Manage',     icon: <FaRoute />, tone: 'cyan' },
  //     { id: 'primary-busowners', label: 'Primary Bus Owner Manage', icon: <BiMale />,  tone: 'amber' }
  //   ]
  // },

  { id: 'BusManagement',         label: 'Bus Manage',              icon: <BiMale />,                   tone: 'amber' },
  { id: 'bus-report',            label: 'Bus Report',              icon: <BiMale />,                   tone: 'cyan' },
  { id: 'bus-owner-report',      label: 'Bus Owner Report',        icon: <FaUserTie />,                tone: 'amber' },
  { id: 'employees',             label: 'Employee Manage',         icon: <FaUserTie />,                tone: 'indigo' },
  { id: 'freelancers',           label: 'Freelancer Manage',       icon: <FiUsers />,                  tone: 'indigo' },
  { id: 'routes',                label: 'Route Manage',            icon: <FaRoute />,                  tone: 'cyan' },
  { id: 'view-routes',           label: 'View Routes',             icon: <FaRoute />,                  tone: 'cyan' },
  { id: 'busroutes',             label: 'Bus Route Manage',        icon: <FaRoute />,                  tone: 'cyan' },
  { id: 'masterroutes',          label: 'Route Master',            icon: <FaRoute />,                  tone: 'cyan' },
  { id: 'bookings',              label: 'Booking Manage',          icon: <TbBrandBooking />,           tone: 'indigo' },
  { id: 'payments',              label: 'Payment Report',          icon: <MdPayment />,                tone: 'green' },
  { id: 'coupons',               label: 'Coupon Manage',           icon: <RiCoupon4Fill />,            tone: 'pending' },
  { id: 'influencers',           label: 'Influencer Manage',       icon: <FaUserTie />,                tone: 'pending' },
  { id: 'owner-commissions',     label: 'Owner Commission',        icon: <FaCommentDollar />,          tone: 'green' },
  { id: 'profit-report',         label: 'Bus Wise Profit Report',  icon: <FaCommentDollar />,          tone: 'green' },
  { id: 'expenses-report',       label: 'Expenses Report',         icon: <FaCommentDollar />,          tone: 'inactive' },
  { id: 'influencer-commissions',label: 'Influencer Commission',   icon: <FaCommentDollar />,          tone: 'green' },
  { id: 'seat-management',       label: 'Seat Management',         icon: <MdAirlineSeatLegroomExtra />,tone: 'indigo' },
  { id: 'customer-care',         label: 'Customer Care',           icon: <FaUserGroup />,              tone: 'pending' },
  { id: 'BookingPolicyManagement',label:'Booking Policy Management',icon:<MdAirlineSeatLegroomExtra />, tone: 'indigo' },
  { id: 'versions',              label: 'Version Management',      icon: <FaUserGroup />,              tone: 'cyan' },
  { id: 'profile',               label: 'Profile Manage',          icon: <CgProfile />,                tone: 'indigo' },
  { id: 'terms',                 label: 'Terms & Conditions',      icon: <TfiWrite />,                 tone: 'inactive' },
];

// ============================================================
// HELPERS
// ============================================================
const isGroupAllowed = (group, allowedMenus) => {
  if (!group.isGroup) return allowedMenus.includes(group.id);
  return group.children.some(child => allowedMenus.includes(child.id));
};
const filterChildren = (group, allowedMenus) => {
  if (!group.isGroup) return group;
  return { ...group, children: group.children.filter(child => allowedMenus.includes(child.id)) };
};

// ============================================================
// SIDEBAR
// ============================================================
const Slidebar = ({
  activeMenu,
  setActiveMenu,
  onToggleCompact,
  userRole,
  allowedMenus,
  isAdmin,
  isFreelancer
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [downloading, setDownloading] = useState({ user: false, partner: false });
  const [hovered, setHovered] = useState(null);

  // Auto-open group if a child is active
  const [openGroups, setOpenGroups] = useState(() => {
    const path = location.pathname.substring(1);
    const open = {};
    allMenuItems.forEach(item => {
      if (item.isGroup && item.children.some(c => c.id === path)) open[item.id] = true;
    });
    return open;
  });

  useEffect(() => {
    const path = location.pathname.substring(1);
    allMenuItems.forEach(item => {
      if (item.isGroup && item.children.some(c => c.id === path)) {
        setOpenGroups(prev => ({ ...prev, [item.id]: true }));
      }
    });
  }, [location.pathname]);

  const toggleGroup = (groupId) => {
    setOpenGroups(prev => ({ ...prev, [groupId]: !prev[groupId] }));
  };

  const visibleMenu = allMenuItems
    .filter(item => isGroupAllowed(item, allowedMenus))
    .map(item => filterChildren(item, allowedMenus));

  const handleMenuClick = (menuId) => {
    setActiveMenu(menuId);
    navigate(`/${menuId}`);
  };

  const isActive = (menuId) => {
    const currentPath = location.pathname.substring(1);
    return currentPath === menuId || (menuId === 'dashboard' && currentPath === '');
  };

  const handleDownload = (type) => {
    setDownloading(prev => ({ ...prev, [type]: true }));
    const apkUrl = type === 'user' ? '/apks/user-app.apk' : '/apks/partner-app.apk';
    const link = document.createElement('a');
    link.href = apkUrl;
    link.download = `roam-${type}-app.apk`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => setDownloading(prev => ({ ...prev, [type]: false })), 2000);
  };

  // ---------- role badge ----------
  const roleBadge = isFreelancer
    ? { label: 'Freelancer', tone: 'pending' }
    : isAdmin
      ? { label: 'Admin', tone: 'active' }
      : { label: 'User', tone: 'inactive' };

  return (
    <aside className="sidebar prm-sidebar">
      {/* ---------- HEADER ---------- */}
      <div className="sidebar-header prm-sidebar-header">
        <div className="prm-sidebar-brand">
          <div className="prm-sidebar-logo">
            <span className="prm-sidebar-logo-dot" />
            <span className="prm-sidebar-logo-dot" />
            <span className="prm-sidebar-logo-dot" />
          </div>
          <div>
            <h2>ROAM</h2>
            <span className="prm-sidebar-tagline">Admin Console</span>
          </div>
        </div>
        <span className={`prm-status ${roleBadge.tone} prm-sidebar-role`}>
          {roleBadge.label}
        </span>
      </div>

      {/* ---------- SEARCH ---------- */}
      <div className="prm-sidebar-search">
        <span className="prm-sidebar-search-icon">
          <IoMdCloudDownload style={{ transform: 'rotate(0deg)' }} />
        </span>
        <input
          type="text"
          placeholder="Search menu…"
          onChange={(e) => {
            const v = e.target.value.toLowerCase();
            setHovered(null);
            document.querySelectorAll('.prm-sidebar .nav-item').forEach(el => {
              const label = el.querySelector('.nav-label')?.textContent?.toLowerCase() || '';
              el.style.display = label.includes(v) ? '' : 'none';
            });
          }}
        />
      </div>

      {/* ---------- NAV ---------- */}
      <nav className="sidebar-nav prm-sidebar-nav">
        <ul>
          {visibleMenu.map((item, idx) => {
            /* ---------- GROUP ---------- */
            if (item.isGroup) {
              const isOpen = !!openGroups[item.id];
              const hasActiveChild = item.children.some(c => isActive(c.id));
              return (
                <li key={item.id} style={{ animationDelay: `${idx * 20}ms` }} className="prm-nav-enter">
                  <button
                    className={`nav-item nav-group-item tone-${item.tone} ${hasActiveChild ? 'has-active-child' : ''} ${isOpen ? 'open' : ''}`}
                    onClick={() => toggleGroup(item.id)}
                    onMouseEnter={() => setHovered(item.id)}
                    onMouseLeave={() => setHovered(null)}
                    aria-expanded={isOpen}
                  >
                    <span className="nav-icon">{item.icon}</span>
                    <span className="nav-label">{item.label}</span>
                    <span className={`nav-group-chevron ${isOpen ? 'open' : ''}`}>
                      {isOpen ? <FaChevronDown /> : <FaChevronRight />}
                    </span>
                  </button>

                  <div className={`nav-group-children ${isOpen ? 'open' : ''}`}>
                    <ul>
                      {item.children.map(child => (
                        <li key={child.id}>
                          <button
                            className={`nav-item nav-child-item tone-${child.tone} ${isActive(child.id) ? 'active' : ''}`}
                            onClick={() => handleMenuClick(child.id)}
                          >
                            <span className="nav-icon">{child.icon}</span>
                            <span className="nav-label">{child.label}</span>
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>
              );
            }

            /* ---------- NORMAL ITEM ---------- */
            const active = isActive(item.id);
            return (
              <li key={item.id} style={{ animationDelay: `${idx * 20}ms` }} className="prm-nav-enter">
                <button
                  className={`nav-item tone-${item.tone} ${active ? 'active' : ''} ${hovered === item.id ? 'hovered' : ''}`}
                  onClick={() => handleMenuClick(item.id)}
                  onMouseEnter={() => setHovered(item.id)}
                  onMouseLeave={() => setHovered(null)}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-label">{item.label}</span>
                  {active && <span className="prm-sidebar-active-dot" />}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>

     

      {/* ---------- FOOTER ---------- */}
      <div className="sidebar-footer prm-sidebar-footer">
        <div className="prm-sidebar-footer-avatar">
          {(isFreelancer ? 'F' : isAdmin ? 'A' : 'U')}
        </div>
        <div>
          <div className="prm-sidebar-footer-role">Logged in as</div>
          <div className="prm-sidebar-footer-name">
            {isFreelancer ? 'Freelancer' : isAdmin ? 'Administrator' : 'User'}
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Slidebar;
